import { createSelector } from 'reselect'
import { get } from 'lodash'

export const getUserCollections = state => state.user.collections

export const getUserCartItems = state => get(state, 'user.cart.entries') || []

export const getUserFavoriteCollectionID = createSelector(
  [getUserCollections],
  collections => {
    return Object.keys(collections).filter(
      collectionID => collections[collectionID].special_role === 'favorite'
    )[0]
  }
)



// WEBPACK FOOTER //
// ./common/selectors/user.js